import { useLayoutEffect, useEffect } from 'react';

var isBrowser = typeof window !== "undefined";
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect };
